import React from "react";

const pillars = [
  {
    title: "Website Builder",
    desc: "Launch storefronts, landing pages, menus, and brand assets without a separate CMS.",
    icon: "🌐",
    tone: "saas-lp-card--blue",
  },
  {
    title: "Operations",
    desc: "CRM, leads, invoices, quotes, receipts, and expenses in one operational hub.",
    icon: "📊",
    tone: "saas-lp-card--indigo",
  },
  {
    title: "Workforce",
    desc: "Staff roles, attendance, tasks, departments, and permission-based access control.",
    icon: "👥",
    tone: "saas-lp-card--purple",
  },
  {
    title: "Automation & AI",
    desc: "Reminders, workflows, and smart tools that reduce manual work across your business.",
    icon: "⚡",
    tone: "saas-lp-card--pink",
  },
];

export default function EcosystemSection() {
  return (
    <section id="ecosystem" className="saas-lp-section">
      <div className="saas-lp-inner">
        <div className="saas-lp-section__header">
          <p className="saas-lp-label">The ecosystem</p>
          <h2>Everything your business needs, connected</h2>
          <p>
            Stop juggling disconnected tools. Beentara links your customer-facing site with
            back-office operations and your team.
          </p>
        </div>

        <div className="saas-lp-grid saas-lp-grid--4">
          {pillars.map((item) => (
            <article key={item.title} className={`saas-lp-card ${item.tone}`}>
              <div className="saas-lp-card__icon">{item.icon}</div>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
